
import { NavLink, useLocation } from "react-router";
import { useState } from "react";
import Pager from "../Common/Pager";

import { useLookupTransactionsQuery } from "../../stores/OkOkStore";
import type { Transactions } from "../../types/Transaction";
import FondInfo from "../Common/FondInfo";
import { useTrads } from "../../contexts/trads/useTrads";
import type { LocationState, QueryParameters } from "../../types/QueryParameters";

function TransactionsList(){
    const [params,setParams]=useState<QueryParameters>({page:0,order:"date_creation",reverse:1});
    const { data, error, isLoading } = useLookupTransactionsQuery(params);
    const {translate}=useTrads();

    const location = useLocation();
    const state = location.state as LocationState | undefined;

    const setPage=function(page:number){
        setParams({...params,page: page})
    }
    const setOrder=function(order:string,reverse?:number){
        setParams({...params,order:order,reverse:reverse ?? 0});
    }
    


    function isModified(id:number){
        if (state?.modified && state.data_id===id){
            return true;
        }
        return false;
    }


    return (
        error ? (
               <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

            ) : isLoading ? (
                <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
            ) : data ? (
        <>
            <Pager curpage={data.page} totalpages={data.pages} setter={setPage}></Pager>
            <table className="table">
                <thead className="sticky-top">
                    <tr>
                        <th scope="col">{translate('transaction_montant')}</th>
                        <th scope="col">{translate('transaction_regle')}</th>
                        <th scope="col" className="table-sort">{translate('transaction_date_creation')}
                            <div className={(params.order=='date_creation')?((params.reverse)?'desc':'asc'):undefined}>
                                <a className='up' onClick={()=>{ setOrder('date_creation',1); }} ><i className="bi"></i></a>
                                <a className='down' onClick={()=>{ setOrder('date_creation',0); }} ><i className="bi"></i></a>
                            </div>
                        </th>
                        <th scope="col">{translate('transaction_fond')}</th>
                        <th scope="col">{translate('transaction_communication')}</th>
                        <th scope="col">#</th>

                    </tr>
                </thead>
                <tbody>
                    {data.data.map((transaction:Transactions) => (
                        <tr key={transaction.id} className={((!transaction.regle)?"table-warning":'')  +(isModified(transaction.id)?" flash":"")  }>
                            <td>{transaction.montant} €</td>
                            <td>{transaction.regle}</td>
                            <td>{transaction.date_creation}</td>
                            <td><FondInfo fondId={transaction.fond_id} /></td>
                            <td>{transaction.communication}</td>
                            <td>
                                <NavLink to={`/transactions/${transaction.id.toString()}`}>
                                    <span className="visually-hidden">{translate('btn_voir')}</span>
                                    <i className="bi bi-eye-fill"></i>
                                </NavLink>
                            </td>
                            
                        </tr>
                    ))}
                </tbody>
            </table>
            <Pager curpage={data.page} totalpages={data.pages} setter={setPage}></Pager>
        </>):null
    );
}
export default TransactionsList;

